import { useAuth } from "react-oidc-context";
import { useOfflineSession } from "common-fe";

// #3256 -- who is scribing on this station. A live (or stored-but-expired)
// OIDC user wins. With none (a browser restart while offline) fall back to the
// last known non-secret identity AuthGate's offline session carries, so the
// outbox is still stamped with the right owner and the seat/assignment reads
// still key on the right sub. `offline` is true only in that no-session case.
// Not a login: auth.isAuthenticated stays false and no token exists.
export function useScribeIdentity() {
  const auth = useAuth();
  const offlineSession = useOfflineSession();
  const liveProfile = auth.user?.profile;
  if (liveProfile?.sub) {
    return { sub: liveProfile.sub, profile: liveProfile, offline: false };
  }
  const cached = offlineSession?.identity;
  if (cached?.sub) {
    return { sub: cached.sub, profile: cached.profile ?? { sub: cached.sub }, offline: true };
  }
  return { sub: null, profile: liveProfile ?? null, offline: false };
}
